import { getLocalStorage } from "../../utils/userHelper";
export const checkExistingFeedback = async (navigate) => {
  if (getLocalStorage("feedbackResumeId")) {
    navigate(
      `/resume-details/${getLocalStorage(
        "feedbackResumeSlug"
      )}/${getLocalStorage("feedbackResumeId")}`
    );
  } else {
    navigate("/");
  }
};
export const checkExistingFileToDownload = async (navigate) => {
  if (getLocalStorage("downloadResumeId")) {
    navigate(
      `/resume-details/${getLocalStorage(
        "downloadResumeSlug"
      )}/${getLocalStorage("downloadResumeId")}`
    );
  } else {
    checkExistingFeedback(navigate);
    // navigate("/");
  }
};
